import React, { useRef, useState, useMemo, useEffect } from "react";
import { useScreenDimensions, useDevice } from "../_layout";

import { Text, View, TouchableOpacity } from "react-native";
import GlobalStyles from "../../Resources/Styles";
import Colors from "../../Resources/Color";
import Fonts from "../../Resources/Fonts";
import { useTranslation } from "react-i18next";
import { Feather } from "@expo/vector-icons";

import { observer, Observer } from "mobx-react";

import ChatMediaPlayer from "../Chat/ChatMediaPlayer";
import CustomAlert from "../Components/CustomAlert";
import ChatManager from "../Classes/ChatManager";
import MediaManager from "../Classes/MediaManager";
import { Chat } from "../../Resources/Constants";
import AudioManager from "../Classes/AudioManager";
import ChatListView from "../Chat/ChatListView";
import ClientNameLogo from "../Chat/ClientNameLogo";
import ChatView from "../Chat/ChatView";
import IconEmptyView from "../Components/IconEmptyView";
import Tooltip from "../Components/Tooltip";

const CoachChat = ({ coach }) => {
  const { screenSize } = useScreenDimensions();
  const { t, i18n } = useTranslation();
  const { isMobile } = useDevice();
  const chatManager = ChatManager.getInstance();
  const mediaManager = MediaManager.getInstance();

  const LEFT_WIDTH = screenSize === "large" ? "27%" : "35%";
  const RIGHT_WIDTH = "25%";

  const SideView = () => {
    return (
      <View
        style={{
          flex: 1,
          paddingHorizontal: 12,
          marginTop: 16,
        }}
      >
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            marginBottom: 20,
            marginLeft: 12,
            marginRight: 12,
            gap: 6,
            justifyContent: "space-between",
          }}
        >
          <Text style={[Fonts.bold24, {}]}>Chats</Text>
          <Observer>
            {() =>
              coach.totalNewChats > 0 && (
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  <Text
                    style={{
                      color: Colors.bubbleColor,
                      backgroundColor: "rgba(0, 0, 0, 0.07)",
                      borderRadius: 12,
                      alignSelf: "center",
                      textAlign: "center",
                      textAlignVertical: "center",
                      fontSize: 11,
                      width: 20,
                      minWidth: 20, //To avoid being compressed when preview text is large
                      height: 20,
                      lineHeight: 20,
                      marginLeft: 8,
                      // borderColor: Colors.grayColor,
                      // borderWidth: 0.5,
                    }}
                  >
                    {coach.totalNewChats <= 99 ? coach.totalNewChats : 99}
                  </Text>
                </View>
              )
            }
          </Observer>

          <View style={{ flex: 1 }} />
          <Tooltip
            delayedOpen={true}
            content="minimizeChat-string"
            placement="bottom"
          >
            <TouchableOpacity
              onPress={() => {
                coach.setProperty("chatIsExpanded", false);
                coach.setProperty("showingChatList", true);
              }}
            >
              <Feather name={"minimize-2"} size={20} color="black" />
            </TouchableOpacity>
          </Tooltip>
        </View>

        <ChatListView coach={coach} fullScreen={true} />
      </View>
    );
  };
  const ClientChatView = observer(({ client }) => {
    const [hoveredButton, setHoveredButton] = useState(null);

    return (
      <View
        style={{
          height: "100%",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          borderLeftWidth: 1,
          borderRightWidth: 1,
          borderColor: Colors.borderColor,
        }}
      >
        {client ? (
          <>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                height: 60,
                borderBottomWidth: coach.selectedChatClient ? 0.1 : 0,
                borderColor: Colors.borderColor,
                flexShrink: 0,
                paddingHorizontal: 16,
                backgroundColor: Colors.whiteColor,
              }}
            >
              <ClientNameLogo client={coach.selectedChatClient} />
              <View style={{ gap: 2 }}>
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  <Text style={{ fontWeight: "600", fontSize: 14 }}>
                    {coach.selectedChatClient.nameForCoach}
                  </Text>
                  <Tooltip
                    delayedOpen={true}
                    content="openAthlete-string"
                    placement="bottom"
                  >
                    <TouchableOpacity
                      onPress={() => {
                        // e.stopPropagation();
                        coach.setProperty("showingChatList", false);
                        coach.selectClient(
                          coach.selectedChatClient.id,
                          t,
                          i18n,
                          false
                        );
                        coach.setProperty("chatIsExpanded", false);
                        setTimeout(() => {
                          coach.setProperty("showingChatList", true);
                        }, 50);
                      }}
                      onMouseEnter={() =>
                        !isMobile && setHoveredButton("openAthlete")
                      }
                      onMouseLeave={() => setHoveredButton(null)}
                      style={{ marginLeft: 4 }}
                    >
                      <Feather
                        name="arrow-up-right"
                        size={14}
                        color={
                          hoveredButton === "openAthlete"
                            ? Colors.darkgrayColor
                            : Colors.grayColor
                        }
                      />
                    </TouchableOpacity>
                  </Tooltip>
                </View>
                <Text style={{ fontSize: 10, color: Colors.grayColor }}>
                  {coach.selectedChatClient.email}
                </Text>
              </View>
            </View>
            <View style={{ flex: 1 }}>
              <ChatView
                client={coach.selectedChatClient}
                height="100%"
                fullScreen={true}
              />
            </View>
          </>
        ) : (
          <IconEmptyView
            iconLibrary="Ionicons"
            iconName="chatbubbles-outline"
            mainText="selectChatTitle-string"
            subText="selectChatText-string"
            marginTop={34}
            marginBottom={16}
          />
        )}
      </View>
    );
  });
  const VideoView = () => {
    return (
      <View
        style={{
          flex: 1,
          padding: 24,
          paddingRight: screenSize === "large" ? 0 : 24,
          justifyContent: "center",
        }}
      >
        <ChatMediaPlayer coach={coach} fullScreen={true} />
      </View>
    );
  };
  return (
    <View
      style={{
        flex: 1,
        height: "100%",
        borderRadius: 16,
        flexDirection: "row",
        marginRight: 24,
      }}
    >
      <Observer>
        {() => (
          <>
            <View
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                bottom: 0,
                width: LEFT_WIDTH,
              }}
            >
              {screenSize === "medium" && mediaManager.showingMediaPlayer ? (
                <VideoView />
              ) : (
                <SideView />
              )}
            </View>
            <View
              style={{
                position: "absolute",
                top: 0,
                right:
                  mediaManager.showingMediaPlayer && screenSize != "medium"
                    ? RIGHT_WIDTH
                    : 0,
                left: LEFT_WIDTH,
                bottom: 0,
                // width: CHAT_WIDTH,
              }}
            >
              <ClientChatView client={coach.selectedChatClient} />
            </View>
            {mediaManager.showingMediaPlayer && screenSize != "medium" && (
              <View
                style={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  bottom: 0,
                  width: RIGHT_WIDTH,
                }}
              >
                <VideoView />
              </View>
            )}
            {chatManager.showingPermissionsAlert && (
              <CustomAlert
                isVisible={chatManager.showingPermissionsAlert}
                onClose={() =>
                  chatManager.setProperty("showingPermissionsAlert", false)
                }
                title={"permissionsAlertTitle-string"}
                text={"permissionsAlertText-string"}
                noTranslateText={true}
              />
            )}
          </>
        )}
      </Observer>
    </View>
  );
};

export default CoachChat;
